<div class="container-fluid">
  <div class="row mx-2">
    <h1 class="col-12 fw-700 mt-3">End User License Agreement (EULA)</h1>
    <p class="col-12 fw-700 my-2">
      <strong>Last Updated: April 15, 2026</strong>
    </p>
    <p class="col-12 my-2 text-justify">
      This End User License Agreement (the "EULA") governs the use of Jikia, dba
      <strong>CitizeX</strong> ("we," "our," or "us") websites, located at
      <a href="http://citizex.ai" target="_blank">citizex.ai</a>, and
      participation in any online features, services, and/or programs offered by
      us (collectively, the "Website" or "Platform").
    </p>
    <p class="col-12 my-2 text-justify fw-700">
      BY ACCESSING OR USING OUR WEBSITES, YOU ARE ENTERING INTO A LEGAL CONTRACT
      WITH JIKIA REGARDING YOUR USE OF THE WEBSITES AND YOU AGREE TO BE BOUND BY
      THIS EULA. IF YOU DO NOT AGREE TO ANY PORTION OF THIS EULA, YOU SHOULD NOT
      ACCESS OR OTHERWISE USE THE WEBSITE.
    </p>
  </div>
  <hr />
  <div class="row mx-2 terms-list-style">
    <div class="col-12">
      <h5 class="fw-700 mt-3">1. CONVENIENCE AND INFORMATION ONLY</h5>
      <p class="mt-2 text-justify">
        The Websites are provided to you as a convenience and for informational
        purposes only. By providing access, we do not warrant that materials or
        content are accurate, complete, or current. Your access to the Website
        may be subject to interruptions or errors; while we utilize SMS for
        account verification and security, we do not guarantee the successful
        delivery of any text message, as delivery is subject to transmission by
        your network operator.
      </p>
      <hr />
      <h5 class="fw-700 mt-3">2. USER ACCOUNT</h5>
      <p class="mt-2 text-justify">
        To access the Platform, you must create a unique User Account. You are
        responsible for maintaining the confidentiality of your login
        credentials and must notify us immediately of any unauthorized use. User
        accounts are unique to an individual person and must not be shared with
        any other individuals or organizations.
      </p>
      <hr />
      <h5 class="fw-700 mt-3">3. ACCURATE AND TRUTHFUL INFORMATION</h5>
      <p class="mt-2 text-justify">
        You agree to provide true, accurate, and current information regarding
        your identity. We may collect and use data, including technical and
        demographic information, in accordance with our Privacy Policy to
        improve our services and ensure platform integrity.
      </p>
      <hr />
      <h5 class="fw-700 mt-3">4. SMS AND MOBILE MESSAGING</h5>
      <p>
        By providing your mobile number and opting in to receive SMS from
        CitizeX, you agree to the following:
      </p>
      <ul style="list-style-type: disc !important; padding-left: 3rem">
        <li class="my-2">
          <strong>Purpose:</strong> CitizeX sends transactional messages,
          including one-time passwords (OTP) and identity verification codes.
        </li>
        <li class="my-2">
          <strong>Opt-Out:</strong> You can cancel the SMS service at any time
          by texting "<strong>STOP</strong>" to the number from which you
          received a message. Upon receiving a "STOP" request, we will send a
          final confirmation message.
        </li>
        <li class="my-2">
          <strong>Help:</strong> For assistance with the messaging program, you
          may reply with the keyword "HELP".
        </li>
        <li class="my-2">
          <strong>Rates &amp; Frequency:</strong> Message and data rates may
          apply. Message frequency is typically one (1) message per verification
          request.
        </li>
        <li class="my-2">
          <strong>Third-Party Hosts:</strong> If you explicitly opt-in to share
          data with a Virtual Event Host, any subsequent SMS communication from
          that Host constitutes a separate relationship between you and said
          Host. CitizeX is not responsible for the content or frequency of
          third-party Host messages.
        </li>
      </ul>
      <hr />
      <h5 class="fw-700 mt-3">5. ACCOUNT DEACTIVATION</h5>
      <p class="mt-2 text-justify">
        We reserve the right to suspend or terminate your account at our
        discretion, including for providing inaccurate information, fraudulent
        use, or allowing unauthorized access to your credentials.
      </p>
      <hr />
      <h5 class="fw-700 mt-3">6. CONTENT AND LICENSING</h5>
      <p class="mt-2 text-justify">
        You are solely responsible for any content you upload. You must have all
        necessary rights and permissions. By posting content, you grant CitizeX
        a worldwide, royalty-free license to use said content. We reserve the
        right to remove any material deemed unlawful, abusive, or inappropriate.
      </p>
      <hr />
      <h5 class="fw-700 mt-3">7. NO WARRANTIES; LIMITATION OF LIABILITY</h5>
      <p class="mt-2 text-justify">
        The Website is provided "as is" without warranties of any kind.
        Jikia/CitizeX is not liable for damages arising from your use of the
        Website. Our total liability is limited to the amounts paid by you, if
        any, in the six months preceding the claim.
      </p>
      <hr />
      <h5 class="fw-700 mt-3">8. INDEMNIFICATION</h5>
      <p class="mt-2 text-justify">
        You agree to indemnify and hold Jikia/CitizeX harmless from any claims,
        losses, or expenses arising from your use of the Platform or any content
        you provide.
      </p>
      <hr />
      <h5 class="fw-700 mt-3">9. PRIVACY POLICY</h5>
      <p class="mt-2 text-justify">
        Your use of the Website is also governed by our Privacy Policy, which is
        incorporated into this EULA by reference. Please review the policy at
        <strong>citizex.ai/privacy-and-policy</strong> for details on how we
        handle your data, including our commitment to not sharing SMS originator
        data with third parties.
      </p>
      <hr />
      <h5 class="fw-700 mt-3">10. JURISDICTION AND VENUE</h5>
      <p class="mt-2 text-justify mb-4">
        This Agreement is governed by the laws of the State of California. Any
        disputes shall be resolved in courts located in the Central District of
        California.
      </p>
    </div>
  </div>
</div>
